import { FormGroup, FormControl, FormArray } from '@angular/forms';

export class ReactiveControlsValidator {
    public static validadeAllFormGroup(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validadeAllFormGroup(control);
            } else if (control instanceof FormArray) {
                control.controls.forEach((ctrl) => this.validadeAllFormGroup(ctrl as FormGroup));
            }
        });
    }

    public static validateFormControl(formGroup: FormGroup, controlName: string): boolean {
        const control = formGroup.get(controlName);
        if (!control) {
            return false;
        }
        return control.invalid && (control.dirty || control.touched);
    }

    public static validateControl(formControl: FormControl): boolean {
        return formControl.invalid && (formControl.dirty || formControl.touched);
    }

    public static markControlAsTouched(control: FormControl) {
        control.markAsTouched({ onlySelf: true });
    }
}
